'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecateFunction;

var _uniqueId = require('transmute/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _devLogger = require('react-utils/devLogger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deprecateFunction() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fn = arguments[1];

  var key = (0, _uniqueId2.default)('deprecated-function-');
  return function () {
    (0, _devLogger.warn)({
      message: 'Deprecation Warning: ' + message,
      key: key
    });
    return fn.apply(undefined, arguments);
  };
}
module.exports = exports['default'];